import { PreFacetsConfig } from '../../../models';

export const DEFAULT_PRE_FACETS_CONFIG: PreFacetsConfig = {};
